import { find, get } from 'lodash';
import { ApplicantEntity } from '@lendi/core-constants';
import { CheckboxGroupItemProps } from '@lendi-ui/checkbox';

import { FIELD_PATHS } from '@funnels/constants';
import { Owner, StoreApplicant } from '@funnels/types';

import getApplicantDisplayName from './getApplicantDisplayName';

function getApplicantOptions(
  applicants: StoreApplicant[] = [],
  addNonApplicant: boolean = true,
  customerApplicantType?: string,
  owners: Owner[] = [],
  includesNonPersonApplicant: boolean = true
): { label: string; value: string }[] {
  const options = applicants
    .filter(
      (applicant) =>
        !customerApplicantType ||
        get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_TYPE(0)) === customerApplicantType ||
        (get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_TYPE(0)) !== customerApplicantType &&
          find(owners, { applicantId: applicant.id }))
    )
    .filter(
      (applicant) =>
        includesNonPersonApplicant ||
        ![ApplicantEntity.Company, ApplicantEntity.Trust].includes(applicant.entity as ApplicantEntity)
    )
    .map((applicant, index) => {
      const displayName = getApplicantDisplayName(applicant);
      const name = displayName ? displayName : `Applicant ${index + 1}`;

      return {
        label: name,
        value: applicant.clientId,
      };
    });

  if (addNonApplicant) {
    options.push({ label: 'Non-applicant', value: '' });
    return options;
  }
  return options;
}

export default getApplicantOptions;
